// General
export const GENERAL_LOGIN_PATH = '/auth/login'
export const GENERAL_FORGOTTEN_PASSWORD_PATH = '/auth/forgottenPassword/:email'
export const GENERAL_RESET_PASSWORD_PATH = '/auth/resetPassword/:userId'
export const GENERAL_SETTINGS = '/settings'

// XTRF
export const XTRF_PROJECTS_LIST_PATH = '/xtrf/projects/list'
export const XTRF_QUOTE_LIST_PATH = '/xtrf/quotes/list'
export const XTRF_PROJECTS_NEW_PATH = '/xtrf/projects/create'
export const XTRF_REPORTS_PATH = '/xtrf/reports'
export const XTRF_PROJECTS_DETAILS_PATH = '/xtrf/projects/details/:type/:id'

// MEMSOURCE
export const MEMSOURCE_PROJECTS_LIST_PATH = '/memsource/projects/list'
export const MEMSOURCE_PROJECTS_DETAILS_PATH = '/memsource/projects/details/:uid'
export const MEMSOURCE_JOBS_LIST_PATH = '/memsource/jobs/list/:internalId?'

// TEMPO
export const TEMPO_DASHBOARD_PATH = '/tempo'
export const TEMPO_PROJECTS_LIST_PATH = '/tempo/projects/list'
export const TEMPO_QUOTES_LIST_PATH = '/tempo/quotes/list'
export const TEMPO_QUOTES_CREATE_PATH = '/tempo/quotes/create'
export const TEMPO_QUOTES_UPDATE_PATH = '/tempo/quotes/update/:id'
export const TEMPO_VALIDATION_PATH = '/tempo/validation'
export const TEMPO_TERMINOLOGY_PATH = '/tempo/terminology'
export const TEMPO_REPORTING_PATH = '/tempo/reporting'
export const TEMPO_STUDIES_PATH = '/tempo/studies'
export const TEMPO_PROJECT_DETAILS_PATH = '/tempo/projects/details/:id'
